module.exports = __webpack_public_path__ + "site/media/jinglebells.2478654f.mp3";